import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, RefreshCw, ArrowLeft } from "lucide-react";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Get failure reason from URL params
  const reason = searchParams.get("reason") || "Payment processing failed. Please try again.";
  const amount = searchParams.get("amount") || "0.00";

  useEffect(() => {
    document.title = "Payment Failed - MyListIQ";
  }, []);

  const handleRetryPayment = () => {
    // Navigate back to the payment page or wherever payment is initiated
    navigate(-1);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        {/* Failure Icon */}
        <div className="text-center">
          <XCircle className="w-20 h-20 text-red-500 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-foreground mb-2">Payment Failed</h1>
          <p className="text-muted-foreground">
            We couldn't process your payment. Please try again.
          </p>
        </div>

        {/* Failure Details Card */}
        <Card>
          <CardHeader>
            <CardTitle>Payment Details</CardTitle>
            <CardDescription>
              Information about your failed payment
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Amount:</span>
              <span className="font-semibold">${amount}</span>
            </div>
            <div className="space-y-2">
              <span className="text-muted-foreground">Reason:</span>
              <p className="text-sm bg-red-50 dark:bg-red-950 text-red-700 dark:text-red-300 p-3 rounded-md border border-red-200 dark:border-red-800">
                {reason}
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button 
            onClick={handleRetryPayment}
            className="w-full"
            size="lg"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Retry Payment
          </Button>
          <div className="grid grid-cols-2 gap-2">
            <Button 
              onClick={handleGoBack}
              variant="outline"
              size="lg"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
            <Button 
              onClick={handleGoToDashboard}
              variant="outline"
              size="lg"
            >
              Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;